import FirebaseModel from "@/Store/ORM/FirebaseORM/FirebaseModel";

export default class BillingSpecial extends FirebaseModel {
	static entity = 'billingSpecials';
	static baseCollection = this.firestore.collection('Configs').doc('Belit').collection('special_scenarios');
	static fields(){
		return {
			name: this.attr(null),
			sample_category_uuid: this.attr(null),
			is_customer: this.attr(null),
			has_tests: this.attr(null),
			has_flags: this.attr(null),
			is_addition: this.boolean(true),
			is_percent: this.attr(false),
			amount: this.number(0),
			...super.fields()
		}
	}
}
